module.exports = __webpack_public_path__ + "static/media/HB_BBQjackfruit_forweb_edited.e38eaabf.jpg";